import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import { required } from 'vuelidate/lib/validators';
import { CLASSES_STORE } from '@/classes/store/classes.store';
import { ClassesService } from '@/classes/services/classes.service';
import { PREFERENCES_VALUES } from '@/classes/values/classes.values';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';

@Component({
  name: 'ed-edit-course-class'
})
export default class EdEditCourseClassComponent extends Vue {

  /* Props */
  @Prop() readonly params: any;

  /* Data */
  public seeContent: boolean = false;
  public saving: boolean = false;
  public loading: boolean = true;
  public loadingContent: boolean = true;
  public teachersObject: any = []
  public courseTeachers: any = []
  public scaleType: string = null;

  /* Computed */
  get writeClassPriv() {
    return this.$store.state.AuthStore.privileges.WriteClass;
  }

  get isMainTeacher() {
    return this.$store.state.AuthStore.user.id === this.params.classItem.teacher.id
  }

  get isCourseTeacher() {
    return this.courseTeachers.includes(this.$store.state.AuthStore.user.id)
  }

  get canEditParams() {
    return this.writeClassPriv || this.isMainTeacher || (!this.params.classItem.allCoursesAccess ? this.isCourseTeacher : false)
  }

  get canEditCourseTeacher () {
    return this.writeClassPriv || this.isMainTeacher 
  }

  get hasGrading() {
    return this.params.course.hasGrading;
  }

  /* Methods */
  mounted() {
    this.getClassTeachers();
  }

  /* Methods */
  saveCourseDetails() {
    this.saving = true;
    let data = {
      'preferences': [
        {
          'preferenceName': PREFERENCES_VALUES.TIME_FRAME_CONTENT_ENABLED,
          'preferenceValue': this.seeContent.toString()
        },
        {
          'preferenceName': PREFERENCES_VALUES.GRADING_METHOD,
          'preferenceValue': this.scaleType.toString()
        }
      ]
    }
    !this.params.classItem.allCoursesAccess
      ? data['courseTeacherIds'] = this.courseTeachers.map(item => item.value)
      : null

    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.UPDATE_COURSE_CONFIG_A}`, {classId: this.params.classItem.id, courseId: this.params.course.id, data}).then(() => {
      this.$EdToast.create({ 
        msg: `${this.$t('classes.success.courseInfoUpdated')}`,
        type: TOAST_TYPES.SUCCESS,
        top: '3rem',
        timeout: 3000
      });
      this.closeModal();
      this.saving = false;
    }).catch(() => {
      this.$EdToast.create({ 
        msg: `${this.$t('classes.errors.courseInfoNoUpdated')}`,
        type: TOAST_TYPES.DANGER,
        top: '3rem',
        timeout: 3000
      });
      this.closeModal();
      this.saving = false;
    })
  }

  getCourseDetails() {
    this.loadingContent = false;

    ClassesService.getCourseConfig(this.params.classItem.id, this.params.course.id)
    .then((res) => {
      this.courseTeachers = res['courseTeachers'].map((el: any) => ({
        text: el.person.firstName,
        value: Number(el.person.id),
      }));

      this.seeContent = res['preferences']
        .find(el => el.preferenceName === PREFERENCES_VALUES.TIME_FRAME_CONTENT_ENABLED).preferenceValue == 'true' ? true : false;

        this.scaleType = res['preferences']
          .find(el => el.preferenceName === PREFERENCES_VALUES.GRADING_METHOD).preferenceValue;
    }).catch(() => {
      this.courseTeachers = []
      this.seeContent = false;
    })
  }

  getOrganizationTeachers() {
    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.SEARCH_USERS_ORGANIZATION_A}`,{
      orgId: this.params.orgId,
      userTypes: 'TEACHER,SDA,SA'
    }).then((res) => {
      this.teachersObject = res.content.map(el => { 
        return {
          'text': el.firstName,
          'value':  el.personId
        }
      })
      this.loading = false;
      this.getCourseDetails();
    }).catch(() => {
      this.teachersObject = []
      this.loading = false;
    })
  }

  getClassTeachers() {
    // Get All Class Teachers
    this.$store.dispatch(`${CLASSES_STORE.ACTIONS.GET_CLASS_TEACHERS_A}`,{
      classId: this.params.classItem.id
    }).then(() => {
      this.getOrganizationTeachers();
    })
  }
  
  closeModal() {
    this.$EdModal.closeModal();
  }
}